/**
 * Permission Module
 */
import router from '../../../router'
import Util from '@/util'
import axios from 'axios'
import { store } from '../../store'

const state = {
  parentId: 0,
  checkPaths: [],
  pathActions: [],
  agentMenu: [],
  pathIdList: [],
  nowPathId: null
}
let paths = []
let pathList = []
let pathActions = []

const checkAgentMenus = (menus) => {
  return new Promise(function (resolve, reject) {
    paths = []
    pathList = []
    pathActions = []
    menus.forEach((d) => {
      if (d.children) {
        d.path = d.children[0].children[0].path
        pathList[d.id] = []
        d.children.forEach((o) => {
          o.children.forEach((c) => {
            pathList[d.id].push(c.path)
            pathActions[c.path] = c.actions
            paths.push(c.path)
            if (c.pages) {
              c.pages.forEach((p) => {
                pathList[d.id].push(p.path)
                pathActions[p.path] = c.actions
                paths.push(p.path)
              })
            }
          })
        })
      } else {
        pathList[d.id] = [d.path]
        pathActions[d.path] = d.actions
        paths.push(d.path)
      }
      if (d.pages) {
        d.pages.forEach((o) => {
          paths.push(o.path)
        })
      }
    })
    store.commit('setCheckPaths', pathList)
    store.commit('setPathActions', pathActions)
    localStorage.setItem('agent-menus', JSON.stringify(menus))
    state.agentMenu = JSON.stringify(menus)
    let route = router.app.$route
    let toPath = route.path
    if (Object.keys(route.params).length > 0) {
      toPath = Util.pathReplace(route.params, toPath)
    }
    if (paths.indexOf(toPath) > -1) {
      resolve(toPath)
    } else {
      reject(paths[0])
    }
  })
}

const getters = {
  getCheckPaths: state => {
    return state.checkPaths
  },
  getPathActions: state => {
    let routeData = router.app.$route
    let toPath = routeData.path
    if (Object.keys(routeData.params).length > 0) {
      toPath = Util.pathReplace(routeData.params, toPath)
    }

    // 티켓 상세 팝업 권한 예외 처리
    if (toPath === '/operation/ticket') {
      toPath = '/ticket/ticket_details'
    }
    return state.pathActions[toPath]
  },
  getAgentMenu: state => {
    return state.agentMenu
  },
  getPathIdList: state => {
    return state.pathIdList
  },
  getNowPathId: state => {
    return state.nowPathId
  }
}

const actions = {
  async agentReset (state, brandId) {
    if (Util.parseLoginToken().agentMappingBrandViews[0].brandId === brandId) {
      return axios({
        method: 'get',
        url: Util.parseLoginToken().admin ? '/api/agent/adminMenus' : `/api/agent/menus?brandId=${brandId}`
      }).then((res) => {
        const responseData = res.data
        if (res.status === 200 && responseData.code === 0) {
          checkAgentMenus(responseData.data).then((path) => {
            router.app.$router.push(path)
          }).catch((path) => {
            router.app.$router.push(path)
          })
        }
      })
    } else {
      return false
    }
  },
  async agentMenuReset (state, brandId) {
    return axios({
      method: 'get',
      url: Util.parseLoginToken().admin ? '/api/agent/adminMenus' : `/api/agent/menus?brandId=${brandId}`
    }).then((res) => {
      const responseData = res.data
      if (res.status === 200 && responseData.code === 0) {
        checkAgentMenus(responseData.data).then((path) => {
          router.app.$router.push(path)
        }).catch((path) => {
          router.app.$router.push(path)
        })
      }
    })
  }
}

const mutations = {
  setCheckPaths (state, statuses) {
    state.checkPaths = statuses
  },
  setPathActions (state, statuses) {
    state.pathActions = statuses
  },
  setPathIdList (state, pathIdList) {
    state.pathIdList = pathIdList
  },
  setNowPathId (state, nowPath) {
    state.nowPathId = nowPath ? state.pathIdList.filter(f => f.name === nowPath)[0].id : null
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/permission/index.js